module.exports = __webpack_public_path__ + "img/Logo.07d3095e.png";